import { render } from "./PcHeader.vue?vue&type=template&id=5b3af2e5&scoped=true"
import script from "./PcHeader.vue?vue&type=script&lang=js"
export * from "./PcHeader.vue?vue&type=script&lang=js"

import "./PcHeader.vue?vue&type=style&index=0&id=5b3af2e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3af2e5"]])

export default __exports__